export const environment = {
  production: false,
  v: '1',
  serverUrl: 'https://vpe-app.com/',
  urlUpload: 'http://vpe-app.com/ws/uploads',
  url_ws:  'http://vpe-app.com/ws',
  logoUrl: 'assets/logo_vpe.png',
  appName: 'vpe',
};